import { ILanding, ILandingDelimiter, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import { useLandingStore, ILandingStore } from "src/modules/pe-landing-module/data/store"

/* Protopia Ecosystem component */
export interface IDelimiterTransformContentProps {
   section: ILandingSection
   children: JSX.Element
}
const DelimiterTransformContent = (props: IDelimiterTransformContentProps): JSX.Element => {
    const currentLanding: ILanding = useLandingStore((state: ILandingStore) => state.currentLanding)
   const delimiter: ILandingDelimiter =  props.section?.delimiter && !!Object.keys(props.section.delimiter).length 
           ?
           {
               ...(currentLanding.delimiter || {}),
               ...props.section.delimiter 
           }
           :
           currentLanding.delimiter || {} 
   return <div className={`landing-delimiter-transform-container `} style={ { ...delimiter?.style, zIndex: delimiter?.z } }>
       {props.children}
    </div>
}
export default DelimiterTransformContent